const backNavItem = ({ text }) => `
    <li class="mega-nav__header -subnav">
        <button type="button" class="mega-nav__back" data-control="back">
            ${text}
        </button>
    </li>
`;

const headingNavItem = ({ levelMod, text, url }) => {
    const modifier = levelMod || '';
    const element = url ? 'a' : 'span';
    const href = url ? `href="${url}"` : '';

    return `
        <li 
            class="mega-nav__item -heading ${url ? '-isAnchor' : ''}" 
            ${!url ? 'aria-hidden="true"' : ''}>

            <${element} 
                ${href} 
                class="mega-nav__link -heading ${modifier}">

                ${text}
            </${element}>
        </li>
    `;
};

const navItem = content => `
    <li class="mega-nav__item">
        ${content}
    </li>
`;

const navItemLink = ({ levelMod, target, text, url }) => {
    const modifier = levelMod || '';

    const attributes = [
        `href="${url}"`,
        `class="mega-nav__link ${modifier}"`,
        `target="${target || '_self'}"`
    ].join(' ');

    return `
        <a ${attributes}>
            ${text}
        </a>
    `;
};

const subNav = ({ content, levelMod } = {}) => {
    const modifier = levelMod || '';

    return `
        <div class="mega-nav__subnav ${modifier}" data-region="menu">
            <ul>
                ${content}
            </ul>
        </div>
    `;
};

const subNavToggle = ({ levelMod, text, url }) => {
    const modifiers = [
        levelMod || '',
        url ? '-hasAnchor': ''
    ].join(' ');

    return `
        <button
            type="button"
            class="mega-nav__link -subnav ${modifiers}"
            data-control="toggle">

            ${text}
        </button>`
};

export {
    backNavItem,
    headingNavItem,
    navItem,
    navItemLink,
    subNav,
    subNavToggle
};
